<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="正在下载新版本"
      :visible.sync="visible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-progress :percentage="percentage"></el-progress>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      percentage: 0,
    };
  },
  created() {
    if (localStorage.getItem("diskSerials")) {
      this.$store.dispatch(
        "setDiskSerials",
        localStorage.getItem("diskSerials")
      );
    }
    if (localStorage.getItem("login_location")) {
      this.$store.dispatch(
        "setLocation",
        JSON.parse(localStorage.getItem("login_location"))
      );
    }
    window.ipcRendererApi?.windowReady((res) => {
      console.log("window-ready", res);
      this.$store.dispatch("setDiskSerials", res.diskSerials.join(""));
      localStorage.setItem("diskSerials", res.diskSerials.join(""));
    });
    window.ipcRendererApi?.downloadProgress((data) => {
      if (data.type && data.type === "update-available") {
        this.$confirm("有新版本可以更新，是否现在开始更新", "提示", {
          confirmButtonText: "现在下载",
          cancelButtonText: "下次再说",
          type: "warning",
        })
          .then(() => {
            window.electron.ipcRenderer.send("downloadNow");
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消更新",
            });
          });
      }
      if (data.type && data.type === "download-progress") {
        this.visible = true;
        this.percentage = data.percent;
        if (this.percentage >= 100) {
          this.visible = false;
        }
      }
      console.log("download progress", data);
    });
    window.ipcRendererApi?.downloaded(() => {
      console.log("downloaded");
      this.$confirm("下载已完成，是否安装", "提示", {
        confirmButtonText: "安装",
        cancelButtonText: "下次再说",
        type: "warning",
      })
        .then(() => {
          window.electron.ipcRenderer.send("updateNow");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消安装",
          });
        });
    });
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f2f4fa;
}
</style>
